module.exports = __webpack_public_path__ + "img/1.9e615d40.jpg";